// LoginPage.tsx
import React, { useEffect, useState } from "react";
import logo from "../../../images/Damas_univ.png";

import { Link, useNavigate } from "react-router-dom";
import Loader from "../../Loader";

import { Bounce } from "react-toastify";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { usePOST } from "../../../ApiS";
import Input from "../../Inputs/Input";

const ForgitPassword: React.FC = () => {
  const notify = (message: string) => {
    toast.error(message, {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Bounce,
    });
  };
  const navigate = useNavigate();
  const { mutation, handleChangeInput, handleSubmit } = usePOST(
    {
      email: "",
    },
    () => navigate("/code"),

    () => notify("الايميل غير صحيح يرجى ادخال ايميل صحيح")
  );

  return (
    <div className="flex-col items-center justify-center h-screen bg-gray-100 mt-12 ">
      <ToastContainer />
      {mutation.isLoading ? <Loader /> : ""}

      <div className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 w-[55%] max-md:w-[97%]  mx-auto">
      <img
          src={logo}
          alt=""
          className=" w-1/2 h-[200px] max-md:h-[100px] mx-auto"
        />
        <div className="mb-4">
          <Input
            type="email"
            name="email"
            onChange={handleChangeInput}
            title="البريد الالكتروني"
            placeholder="البريد الالكتروني"
            className="!w-full"
          />
        </div>
        <div>
          <button
            className="w-[30%]  bg-primary rounded-xl text-white font-bold p-2 "
            onClick={() => {
              handleSubmit("admin/send/verification-code");
            }}
          >
            التالي
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForgitPassword;
